import { DBTransferOrderType } from '@prisma/client';
import { WmsIcon, wmsIcons } from '@tyrio/wms-ui-library';

export const Icon = ({ type }: { type: DBTransferOrderType }) => {
  if (type === DBTransferOrderType.OUTBOUND)
    return <WmsIcon icon={wmsIcons.outbound} viewBox="0 0 20 19" />;
  else return <WmsIcon icon={wmsIcons.inbound} viewBox="0 0 20 19" />;
};
